import { Component } from '@angular/core';
import { ApplyButtonComponent } from '../../../shared/components/apply-button/apply-button.component';
@Component({
  selector: 'app-hesitation-section',
  standalone: true,
  imports: [ApplyButtonComponent],
  templateUrl: './hesitation-section.component.html',
  styleUrls: ['./hesitation-section.component.scss']
})
export class HesitationSectionComponent {} 